import { httpRequest } from "../../../utils/HttpRequest";
import { ITechnicianList, ITechnicianSearch, ITechnicianDetSearch, ITechnicianDetList } from "./technicianTypes"
class Technicianervice {
    async technicianTotal(params: ITechnicianSearch) {
        const apiUrl = `/vrm-sa/statistics/technicianTotal`;
        return await httpRequest.post<ITechnicianList>(apiUrl, params);
    }
    async technicianDetails(params: ITechnicianDetSearch) {
        const apiUrl = `/vrm-sa/statistics/technicianDetails`;
        return await httpRequest.post<ITechnicianDetList>(apiUrl, params);
    }
    async technicianTotalExcel(params: ITechnicianSearch) {
        const apiUrl = `/vrm-sa/statistics/technicianTotalExcel`;
        return await httpRequest.postFile(apiUrl, params);
    }
    async technicianDetailsExcel(params: ITechnicianSearch) {
        const apiUrl = `/vrm-sa/statistics/technicianDetailsExcel`;
        return await httpRequest.postFile(apiUrl, params);
    }
}
export const technicianService = new Technicianervice();
